import request from '@/utils/request'

// 公共介面 涉及 員工 部門 等 使用頻率較高 但分散 的介面
// 許可權範圍內的使用者列表
/**
 *
 * @param {*} data
 * 1.預設全部
 *
 * 2.模組下許可權內
 * m
 * c
 * a
 *
 *
 */
export function usersList(data) {
  return request({
    url: 'admin/users/getUserList',
    method: 'post',
    data: data
  })
}

// 部門列表
export function depList(data) {
  return request({
    url: 'admin/structures/index',
    method: 'post',
    data: data
  })
}

// 獲取許可權範圍內部門介面
export function adminStructuresSubIndex(data) {
  return request({
    url: 'admin/structures/subIndex',
    method: 'post',
    data: data
  })
}

// 部門下的員工 structure_id
export function userListByStructid(data) {
  return request({
    url: 'admin/users/userListByStructid',
    method: 'post',
    data: data
  })
}

// 根據部門獲取許可權範圍內員工介面
export function getSubUserByStructrue(data) {
  return request({
    url: 'admin/structures/getSubUserByStructrue',
    method: 'post',
    data: data
  })
}

/**
 *
 * @param {*} data
 * 附件上傳 file module module_id
 */
export const crmFileSaveUrl = 'admin/file/save'

export function crmFileSave(data) {
  var param = new FormData()
  Object.keys(data).forEach(key => {
    param.append(key, data[key])
  })
  return request({
    url: 'admin/file/save',
    method: 'post',
    data: param,
    headers: {
      'Content-Type': 'multipart/form-data'
    }
  })
}

// 附件列表
export function crmFileIndex(data) {
  return request({
    url: 'admin/file/index',
    method: 'post',
    data: data
  })
}

/** 暫時客戶管理裡面也有 */
// 附件刪除介面
export function crmFileDelete(data) {
  return request({
    url: 'admin/file/delete',
    method: 'post',
    data: data
  })
}

// 附件重新命名
export function crmFileUpdate(data) {
  return request({
    url: 'admin/file/update',
    method: 'post',
    data: data
  })
}

// crm 自定義欄位的新增
/**
 *
 * @param {*} data
 * 操作方法 (save:新增、update:編輯、read:詳情、index:列表)
 * 操作ID (如：客戶ID)
 */
export function filedGetField(data) {
  return request({
    url: 'admin/field/getField',
    method: 'post',
    data: data
  })
}

// 許可權數據返回
export function adminIndexAuthList(data) {
  return request({
    url: 'admin/index/authList',
    method: 'post',
    data: data
  })
}

// 檔案靜態資源下載
export function adminFileDownload(data) {
  return request({
    url: 'admin/file/download',
    method: 'post',
    responseType: 'blob',
    data: data
  })
}

/**
 * 員工匯入模板下載
 * @param {*} data
 *
 */
export const userExcelDownloadURL = 'admin/users/excelDownload'


// 員工匯入
export function userExcelImport(data) {
  var param = new FormData()
  Object.keys(data).forEach(key => {
    param.append(key, data[key])
  })
  return request({
    url: 'admin/users/import',
    method: 'post',
    data: param,
    headers: {
      'Content-Type': 'multipart/form-data'
    },
    timeout: 600000
  })
}


